import { memo } from 'react';

import { ImageIcon } from '@air/design-icons';

import { WorkspaceAgentPillThumbnail } from '~/components/v2/components/workspace/workspace-agent-panel/components/shared/WorkspaceAgentPillThumbnail';
import { WorkspaceAgentReferencePill } from '~/components/v2/components/workspace/workspace-agent-panel/components/shared/WorkspaceAgentReferencePill';

export type WorkspaceAgentComposerContextSourceFieldValuePillProps = {
  isSelected: boolean;
  label: string;
  onRemove: () => void;
  thumbnailUrl: string | null;
};

/**
 * The composer chip for one brand kit image. It draws entirely from the node's attrs and asks for
 * nothing: the row the user picked already carried the still and the label, and a preview card for
 * a kit value has no second thing to say about it (WORK-500 ships the chip; the card is a follow-on).
 */
export const WorkspaceAgentComposerContextSourceFieldValuePill = memo(
  ({ isSelected, label, onRemove, thumbnailUrl }: WorkspaceAgentComposerContextSourceFieldValuePillProps) => (
    <WorkspaceAgentReferencePill
      card={null}
      isSelected={isSelected}
      kind="Brand kit image"
      leadingVisual={
        <WorkspaceAgentPillThumbnail
          fallback={<ImageIcon aria-hidden size="xs" />}
          testId="WORKSPACE_AGENT_PILL_THUMBNAIL"
          url={thumbnailUrl}
        />
      }
      onRemove={onRemove}
      surface="composer"
      title={label}
      triggerTestId="WORKSPACE_AGENT_PILL_TRIGGER"
    />
  ),
);

WorkspaceAgentComposerContextSourceFieldValuePill.displayName = 'WorkspaceAgentComposerContextSourceFieldValuePill';
